import type * as React from 'react';
import { Dropdown, Option } from '../../Dropdown';
import ToolbarButton from './button';
import styles from './style.m.less';

interface BaseProps {
    quill: {};
    getLastSelection: () => void;
}

interface Options {
    key: string;
    onClick: ({ quill, getLastSelection }: BaseProps) => void;
    label: React.ReactElement | string;
}

interface Props extends BaseProps {
    options: Options[];
}

export default function Insert({ quill, getLastSelection, options }: Props) {
    return (
        <>
            {options.length > 1 && (
                <Dropdown kind="PLAIN" buttonClass={styles.dropdownButton} label="Insert" tabIndex="-1">
                    {options.map(({ key, onClick, label }) => (
                        <Option key={key} onClick={() => onClick({ quill, getLastSelection })}>
                            {label}
                        </Option>
                    ))}
                </Dropdown>
            )}
            {options.length === 1 && (
                <div className="ui-dropdown">
                    <ToolbarButton type="button" onClick={() => options[0].onClick({ quill, getLastSelection })}>
                        Insert
                    </ToolbarButton>
                </div>
            )}
        </>
    );
}
